import { apiDelete, apiGet } from "../../../API/Service/apiClient";

   
export const handleGet_categoryList = async ({
  setLoading,
  filter,
  setDataList,
  setFilteredList,
  showAlert,
  setTotalRecords,setTotalPages,
}) => {
  setLoading(true);
  try {
    const resData = await apiGet("catg-data", filter || {});
    setDataList(resData?.data)
    setFilteredList(resData?.data)
    setTotalRecords(resData?.totalCount)
    setTotalPages(resData?.totalPages)
  } catch (err) {
    showAlert({
      title: "Error",
      message: err?.message || "Something went wrong. Please try again.",
      type: "error",
      confirmLabel: "Ok",
    });
  } finally {
    setLoading(false);
  }
};

export const handleDelete_categoryList = async({
  setActionLoading,data,showAlert,setFilteredList,setDataList
})=>{    
  if(data?.action === "subcategory"){
    setActionLoading({delSubId:data?.id})  
  }else{
    setActionLoading({delId:data?.id})  
  }
  try {    
    const resData =await apiDelete("catg-data",data);     
     if(resData?.data > 0){
      showAlert({
        title: "Success",
        message: "Record deleted successfully",
        type: "success",
        confirmLabel: "Ok",
        cancelLabel: "Cancel", 
        showCancel: false,                 
        onConfirm:()=>{    
          const isSubCategory = data?.category > 0;
          setFilteredList((prevList) => {
            // SUB CATEGORY DELETE
            if (isSubCategory) {
          
              return prevList.map((item) =>
                item?.id === data?.category
                  ? {
                      ...item,
                      sub_categories: item?.sub_categories?.filter(
                        (sub) => sub?.id !== data?.id
                      ),
                    }
                  : item
              );
            }
          
            // CATEGORY DELETE
            return prevList.filter(
              (item) => item?.id !== data?.id
            );
          });

          setDataList((prevList) => {
            // SUB CATEGORY DELETE
            if (isSubCategory) {
          
              return prevList.map((item) =>
                item?.id === data?.category
                  ? {
                      ...item,
                      sub_categories: item?.sub_categories?.filter(
                        (sub) => sub?.id !== data?.id
                      ),
                    }
                  : item
              );
            }
          
            // CATEGORY DELETE
            return prevList.filter(
              (item) => item?.id !== data?.id
            );
          });

        }
      });
      
     }else{
      showAlert({
        title: "Error?",
        message: "Something went wrong. Please try again later.",
        type: "error",
        confirmLabel: "Ok",
        cancelLabel: "Cancel", 
        showCancel: false,         
      });
     }
  } catch (error) {
    showAlert({
      title: "Error?",
      message: "Oops! Something went wrong. Please try again later.",
      type: "error",
      confirmLabel: "Ok",
      cancelLabel: "Cancel", 
      showCancel: false,         
    });
  }finally{
    setActionLoading({})
  }
}